import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import "./assets/css/bootstrap.min.css";
import "./assets/css/bootstrap.rtl.min.css";
// import "./assets/fonts/yekan/Yekan.ttf";
import { CarContextProvider } from "./context/car/car-context";
import { Provider } from "react-redux";
import store from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<React.StrictMode>
  <Provider store={store}>
    <CarContextProvider>
      <App />
    </CarContextProvider>
  </Provider>

  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// src/index.js (فقط ثبت ساده SW)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/custom-sw.js', { scope: '/' })
  .then(reg => console.log('SW registered at scope:', reg.scope))
  .catch(err => console.error('SW registration failed:', err));
      // .then((registration) => {
      //   console.log('SW registered successfully: ', registration);
      // })
      // .catch((error) => {
      //   console.log('SW registration failed: ', error);
      // });
  });
}